import { render, staticRenderFns } from "./MailDetails.vue?vue&type=template&id=d88d3120&scoped=true&"
import script from "./MailDetails.vue?vue&type=script&lang=js&"
export * from "./MailDetails.vue?vue&type=script&lang=js&"
import style0 from "./MailDetails.vue?vue&type=style&index=0&id=d88d3120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88d3120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d88d3120')) {
      api.createRecord('d88d3120', component.options)
    } else {
      api.reload('d88d3120', component.options)
    }
    module.hot.accept("./MailDetails.vue?vue&type=template&id=d88d3120&scoped=true&", function () {
      api.rerender('d88d3120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/mails/MailDetails.vue"
export default component.exports